import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/usuario-acesso-campo/';

class UsuarioAcessoCampoService {
  constructor() {
    LoginService.currentUser.subscribe((data) => {
      this.headers = {
        'Content-Type': 'application/json',
        authorization: 'Bearer ' + (data ? data.token : ''),
      };
    });
  }

  buscarCamposPorPaginaEUsuario(paginaId, usuarioId) {
    return axios.get(`${API_URL}usuario/${usuarioId}/pagina/${paginaId}`, { headers: this.headers });
  }

  buscarPermissoesCamposPorNomes(usuarioId, nomeCampo) {
    return axios.get(`${API_URL}usuario/${usuarioId}/campo/${nomeCampo}/habilitado`, { headers: this.headers });
  }

  salvarPermissoesCampos(campos) {
    return axios.post(`${API_URL}salvar`, campos, { headers: this.headers });
  }
}

export default new UsuarioAcessoCampoService();
